import axios from "axios"
import { createError, getErrorMessage } from "./helpers"

export const initWithdrawView = (gameId: string, userId: string) => {
  console.log(gameId, userId)
  window.withdrawData = {
    gameId,
    userId,
    loading: false
  }
}

export const onWithdrawSubmit = async(event: SubmitEvent) => {
  event.preventDefault()

  if (window.withdrawData.loading) {
    return
  }

  window.withdrawData.loading = true

  const submitButton = document.getElementById("withdraw-submit") as HTMLButtonElement
  submitButton?.classList.add("loading")
  submitButton?.setAttribute("disabled", "")

  try {
    const form = event.target as HTMLFormElement
    const formData = new FormData(form)
    const address = formData.get("address") as string


    await axios.post("/withdraw", {
      ...window.withdrawData,
      address
    })

    window.open("/withdraw-success", "_self")
  } catch (e) {
    const err = getErrorMessage(e)
    console.warn(err)
    createError(err)
  }

  submitButton?.classList.remove("loading")
  submitButton?.removeAttribute("disabled")
  window.withdrawData.loading = false
}
